module.exports = __webpack_public_path__ + "img/transporter-6.e23175bc.svg";